import { useDispatch } from "react-redux"
import { Box, Typography } from "@mui/material"
import BaseButton from "../BaseButton"
import { openModal } from "../../store"

const PatientListOrderKit = () => {
    const dispatch = useDispatch()
    const handleOrderKit = () =>{ 
        dispatch(
            openModal({
                currentModal: 'OPEN_ORDER_KITS_MODAL',
                modalProps: {}
            })
        )
    }
 return (
    <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '20px',
            borderTop: '3px solid #ABB7C0'
        }}
        pt={2}
    >
        <Typography variant="h4">
            Need more kits? Order more
        </Typography>
        <BaseButton
            buttonType={'primary'}
            sx={{
                maxWidth: '459px',
                mb: { xs: '8px', md: '0' },
                display: 'flex',
                alignItems: 'center',
                borderRadius: '100px',
            }}
            onClick={handleOrderKit}
        >
            Order more kits
        </BaseButton>
    </Box>
 )   
}

export default PatientListOrderKit